module.exports = __webpack_public_path__ + "static/media/icon-topical-worksheet-white.7ec0a016.svg";